import * as THREE from 'three';

export class Renderer {
  readonly gl: THREE.WebGLRenderer;
  private resizeObserver: ResizeObserver;

  constructor(canvasId: string, onResize: (w: number, h: number) => void) {
    const canvas = document.getElementById(canvasId);
    if (!(canvas instanceof HTMLCanvasElement)) {
      throw new Error(`Canvas element #${canvasId} not found`);
    }

    this.gl = new THREE.WebGLRenderer({ canvas, antialias: true });
    this.gl.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    const container = canvas.parentElement ?? document.body;
    this.resizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;
      const { width, height } = entry.contentRect;
      this.resize(width, height);
      onResize(width, height);
    });
    this.resizeObserver.observe(container);

    // Initial size
    const { width, height } = container.getBoundingClientRect();
    this.resize(width, height);
    onResize(width, height);
  }

  resize(width: number, height: number): void {
    this.gl.setSize(width, height, false);
  }

  render(scene: THREE.Scene, camera: THREE.Camera): void {
    this.gl.render(scene, camera);
  }

  dispose(): void {
    this.resizeObserver.disconnect();
    this.gl.dispose();
  }
}
